// extracted by mini-css-extract-plugin
export default {"container":"SM1hdUXkfPOVUPloDjbc","canvas":"g90d4JQXl1hFgstdxMOH"};